import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from '../BaseIcon';
export const Play = ({ height = '24px', fill, width = '24px', className }) => {
    return (_jsx(BaseIcon, { height: height, width: width, viewBox: '0 0 24 24', className: className, fill: fill, children: _jsx("path", { d: 'M16.7403 11.5659C17.0762 11.7578 17.0762 12.2422 16.7403 12.4341L7.74807 17.5725C7.41474 17.763 7 17.5223 7 17.1384V6.86159C7 6.47768 7.41474 6.23699 7.74807 6.42747L16.7403 11.5659Z', fill: fill }) }));
};
//# sourceMappingURL=Play.js.map